import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IUser } from '../models/user';
@Injectable({
    providedIn: 'root'
})
export class UserService {
    constructor(private http: HttpClient) { }

    getUser(): Observable<IUser> {
        return this.http
            .get<IUser>('/api/user');
    }

    login(): void {
        window.location.href = '/api/user/login';   
    }

    logout(): Observable<void> {
        return this.http
            .get<void>('/api/user/logout');
    }
}
